import generateIcon from './generateIcon';
var WarnSvg = "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.999 4.714c-.711 0-1.275.6-1.232 1.31l.533 8.747a.7.7 0 001.398 0l.533-8.748c.043-.71-.521-1.309-1.232-1.309zm0 12.43a1.071 1.071 0 100 2.142 1.071 1.071 0 000-2.143z\"/></svg>";
export default generateIcon(WarnSvg, {
  name: 'WarnOutlined'
});